module.exports = __webpack_public_path__ + "img/sidebar-fold-out-icon.8553def7.png";